import React from 'react';

const EditingWorkNote = ({ editingWork, inline = false }) => {
  if (!editingWork?.url) {
    return null;
  }

  return (
    <p className="editing-work-text">
      {editingWork.text}
      {inline ? ' ' : <br />}
      <a
        href={editingWork.url}
        target="_blank"
        rel="noopener noreferrer"
        className="editing-work-link"
      >
        {editingWork.linkText}
      </a>
    </p>
  );
};

export default EditingWorkNote;
